"use client";
import { Turnstile, TurnstileInstance } from "@marsidev/react-turnstile";
import { Ref, useEffect, useImperativeHandle, useRef } from "react";

export type TurnstileWidgetHandle = {
    /** Tokens are single-use: call after every verify attempt so the next submit gets a fresh one. */
    reset: () => void;
};

export default function TurnstileWidget({
    onToken,
    action = "turnstile-spin-v1",
    ref,
}: {
    onToken: (token: string) => void;
    action?: string;
    ref?: Ref<TurnstileWidgetHandle>;
}) {
    const siteKey = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY;
    const skip = process.env.NEXT_PUBLIC_SKIP_RECAPTCHA === "true" || !siteKey;
    const widgetRef = useRef<TurnstileInstance>(null);

    useEffect(() => {
        if (skip) onToken("skip-captcha");
    }, [skip, onToken]);

    useImperativeHandle(ref, () => ({
        reset: () => {
            if (skip) return;
            onToken("");
            widgetRef.current?.reset();
        },
    }));

    if (skip) return null;

    return (
        <Turnstile
            ref={widgetRef}
            siteKey={siteKey!}
            options={{
                action,
                language: "tr",
                theme: "light",
                size: "flexible",
            }}
            onSuccess={onToken}
            onExpire={() => onToken("")}
            onError={() => onToken("")}
        />
    );
}
